import { motion } from "framer-motion";

export const ProcessSection = (props: any) => {
  return (
    <section className="bg-gray-90 py-20 sm:py-24">
      <div className="mx-auto max-w-7xl px-6 sm:px-8">

        {/* Header */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center max-w-3xl mx-auto"
        >
          <p className="text-xs font-semibold uppercase tracking-[3px] text-[#A60000]">
            How We Work
          </p>

          <h2 className="mt-4 text-3xl sm:text-4xl font-extrabold text-gray-900">
            {props.title}
          </h2>

          <p className="mt-4 text-base sm:text-lg text-gray-600 leading-relaxed">
            {props.description}
          </p>
        </motion.div>

        {/* Steps */}
        <ul className="mt-16 grid grid-cols-1 gap-12 lg:grid-cols-4">
          {props.stepsList.map((step: any, idx: number) => (
            <motion.li
              key={idx}
              initial={{ opacity: 0, y: 24, scale: 0.95 }}
              whileInView={{ opacity: 1, y: 0, scale: 1 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: idx * 0.15 }}
              whileHover={{ y: -6 }}
              className="
                relative group rounded-2xl bg-white
                border border-gray-200 p-6
                transition-all duration-300
                hover:border-[#A60000]
                hover:shadow-lg
              "
            >
              {/* Connector (desktop only) */}
              {idx !== props.stepsList.length - 1 && (
                <span
                  className="
                    absolute top-1/2 left-full hidden h-px w-12
                    bg-gray-200 lg:block
                    group-hover:bg-[#A60000] transition-colors
                  "
                  aria-hidden="true"
                />
              )}

              {/* Icon */}
              <motion.div
                whileHover={{ scale: 1.1 }}
                transition={{ type: "spring", stiffness: 300 }}
                className="
                  flex h-12 w-12 items-center justify-center
                  rounded-xl border border-gray-200
                  bg-gray-50 text-[#A60000]
                  mb-6
                  group-hover:bg-[#A60000]
                  group-hover:text-white
                  transition-all
                "
              >
                {step.icon}
              </motion.div>

              {/* Content */}
              <h3 className="text-lg font-semibold text-gray-900 group-hover:text-[#A60000] transition-colors">
                {step.title}
              </h3>

              <p className="mt-2 text-sm text-gray-600 leading-relaxed">
                {step.description}
              </p>
            </motion.li>
          ))}
        </ul>

      </div>
    </section>
  );
};
